module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-10.db9c2e80.png";